import "./OptionSelectComponent.scss";
import {IComponentOptions, IFormController, IOnChanges, IOnChangesObject} from "angular";
import {ComponentCallback} from "../../../types/AngularJS";
import {OptionChainService} from "../../../services/option-chain/OptionChainService";
import {formatDate} from "../../../js/util/DateTimeUtil";

export const OptionSelect = "tfOptionSelect";

export function optionSelect(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/components/option-select/OptionSelectComponent.html",
        require: {
            form: "^^?form"
        },
        bindings: {
            underlying: "<",
            asAt: "<",
            code: "<",
            required: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: OptionSelectComponentController
    };
}

const VALIDATION_KEY = "required-code";

export class OptionSelectComponentController implements IOnChanges {

    public underlying: string;
    public asAt: Date;
    public code: string;
    public required: boolean | null;
    public onChange: ComponentCallback;

    public form: IFormController | null;

    public disabled = false;

    private chainService: OptionChainService;

    /** @ngInject */
    public constructor(optionChainService: OptionChainService) {
        this.chainService = optionChainService;
    }

    public $onChanges(changes: IOnChangesObject): void {
        this.validate();
        this.updateStatus();
    }

    private validate() {
        if (this.form == null) {
            return;
        }
        if (this.required == null || !this.required) {
            this.form.$setValidity(VALIDATION_KEY, true, this.form);
        } else {
            const valid = this.code != null;
            this.form.$setValidity(VALIDATION_KEY, valid, this.form);
        }
    }

    private updateStatus() {
        this.disabled = (this.underlying == null) || (this.asAt == null);
    }

    public async open() {
        try {
            const formatted = formatDate(this.asAt, "YYYY-MM-DD");
            const selected = await this.chainService.open(this.underlying, formatted, this.code);
            if (selected.code !== this.code) {
                this.onChange({ option: selected });
            }
        } catch (e) {
        }
    }
}
